import { useGetFrontRisorseCondiviseIdMetadatiDoc } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { useParams } from 'react-router';
import { PageLayout } from '../../ui/layout/PageLayout';
import { NetworkAlertPage } from '../errors/network-alert/NetworkAlertPage';
import { LoadingPage } from '../loading/LoadingPage';
import { SharedResourceContent } from './SharedResourceContent';
import type { SharedResourceDocument } from './sharedResourceTypes';

export function SharedResourcePage() {
  const { t } = useTranslation();
  const { maskedId = '' } = useParams<{ maskedId: string }>();

  const { data, isLoading, error } =
    useGetFrontRisorseCondiviseIdMetadatiDoc<SharedResourceDocument>(maskedId);

  if (isLoading) {
    return (
      <PageLayout variant="public">
        <LoadingPage noLayout />
      </PageLayout>
    );
  }

  if (error || !data) {
    return (
      <PageLayout variant="public">
        <NetworkAlertPage
          noLayout
          error={error ?? undefined}
          message={t(
            'shared-resource.load-error',
            'Non è stato possibile recuperare le informazioni del documento.',
          )}
        />
      </PageLayout>
    );
  }

  return (
    <PageLayout variant="public">
      <SharedResourceContent maskedId={maskedId} data={data} />
    </PageLayout>
  );
}
